module.exports = __webpack_public_path__ + "static/media/old sanlam-real-assets.6dc9617e.csv";